import { forwardRef } from "react";
import { twMerge } from "tailwind-merge";
import type { ControlSize } from "../types";
import {
  controlGroupContentSizeStyles,
  controlGroupSizeStyles,
} from "./styles";

export interface ControlGroupAddonProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: ControlSize;
}

const ControlGroupAddon = forwardRef<HTMLSpanElement, ControlGroupAddonProps>(
  ({ className, size, style, ...props }, ref) => (
    <span
      {...props}
      ref={ref}
      style={{ ...(size ? controlGroupSizeStyles[size] : undefined), ...style }}
      className={twMerge(
        "flex h-full shrink-0 items-center bg-gunmetal-50 text-gunmetal-900",
        controlGroupContentSizeStyles,
        className,
      )}
    />
  ),
);

export default ControlGroupAddon;
